import config from '@/config/index';

/**
 * 根据社会信用代码获取机构信息
 * @param scc   社会信用代码
 * @param request
 * @GetMapping("/organizationbyscc/{scc}")
 */
function getOrgByScc(scc) {
	return `${config.HOST_API}${config.BASE_API_PREFIX}/organizationbyscc/${scc}`;
}

/**
 * 申请加入某机构
 *
 * @param orgid         机构ID
 * @param apply_uid     申请加入机构的用户ID
 * @param department    部门
 * @param jobstation    职位
 * @param request
 * @PostMapping("/applyjoinorg")
 */
function applyJoinOrg() {
	return `${config.HOST_API}${config.BASE_API_PREFIX}/applyjoinorg`;
}

/**
 * 机构管理员获取某个正在申请加入的用户信息
 * @param apply_uid
 * @param request
 * @GetMapping("/getapplyorginfoofuser/{uid}")
 */
function getApplyOrgInfoOfUser(apply_uid) {
	return `${config.HOST_API}${config.BASE_API_PREFIX}/getapplyorginfoofuser/${apply_uid}`;
}

/**
 * 机构管理员审核待加入的员工
 *
 * @param orgid         机构ID
 * @param apply_uid     申请加入机构的用户ID
 * @param department    部门
 * @param jobstation    职位
 * @param request
 * @PostMapping("/auditjoinorg")
 */
function auditJoinOrg() {
	return `${config.HOST_API}${config.BASE_API_PREFIX}/auditjoinorg`;
}

/**
 * 机构管理员获取所有员工
 *
 * @param orgid        机构ID
 * @param apply_org_checked  待审核状态 0-待审核  1-已审核 9-全部
 * @param page         当前第几页
 * @param limit        限制多少页
 * @param request
 * @GetMapping("/orguserlist")
 */
function getOrgUserList() {
	return `${config.HOST_API}${config.BASE_API_PREFIX}/orguserlist`;
}

/**
 * 机构管理员修改员工信息
 *
 * @param apply_uid  待修改的员工账户ID
 * @param department 部门
 * @param jobstation 职位
 * @param request
 * @PostMapping("/modifyorguser")
 */
function modifyOrgUser() {
	return `${config.HOST_API}${config.BASE_API_PREFIX}/modifyorguser`;
}

/**
 * 机构管理员删除员工信息(抹了与机构相关的信息)
 *
 * @param apply_uid 待修改的员工账户ID
 * @param request
 * @return
 * @PostMapping("/deleteorguser")
 */
function deleteorguser() {
	return `${config.HOST_API}${config.BASE_API_PREFIX}/deleteorguser`;
}

export{
	getOrgByScc,
	applyJoinOrg,
	getApplyOrgInfoOfUser,
	auditJoinOrg,
	getOrgUserList,
	modifyOrgUser,
	deleteorguser
}